export function FieldError({ show = true, message }: { show?: boolean; message?: string }) {
  if (!show || !message) return null;
  return <p className="!mt-0 block text-[13px] leading-4 text-[crimson]">{message}</p>;
}
